(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retreat-native-payment"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('retreat-payment')) {
  customElements.define('retreat-payment', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form[action*="/cart/add"]');
      if (!this.form) return;
      this.messages = JSON.parse(this.querySelector('[data-payment-messages]').textContent);
      queueMicrotask(() => { if (this.dataset.designMode === 'true') { this.querySelector('[data-prepare]').hidden = false; return; } const url = new URL(location.href); if (url.searchParams.get('rp_payment') === this.dataset.sectionId) this.restorePayment(); else this.prepare(); });
      this.querySelector('[data-apply-discount]').addEventListener('click', () => this.applyDiscount());
      this.querySelector('[data-discount-code]').addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); this.applyDiscount(); } });
      this.form.addEventListener('submit', event => { event.preventDefault(); this.prepare(); });
      this.form.addEventListener('change', event => {
        this.querySelector('[data-payment]').hidden = true;
        this.querySelector('[data-prepare]').hidden = true;
        this.querySelector('[data-status]').textContent = '';
        clearTimeout(this.syncTimer);
        if (this.dataset.designMode !== 'true') this.syncTimer = setTimeout(() => this.prepare(), 500);
        const chosen = this.form.querySelector('input[name="id"]:checked');
        const quantity = this.form.querySelector('input[name="quantity"]');
        if (!chosen || !quantity) return;
        const min = Number(chosen.dataset.min) || 1;
        const step = Number(chosen.dataset.step) || 1;
        quantity.min = min;
        quantity.step = step;
        if (chosen.dataset.max) quantity.max = chosen.dataset.max;
        else quantity.removeAttribute('max');
        if (event.target.name === 'id') {
          let value = Math.max(min, Number(quantity.value) || min);
          value = min + Math.floor((value - min) / step) * step;
          if (quantity.max) value = Math.min(value, Number(quantity.max));
          quantity.value = value;
        }
        const currency = JSON.parse(this.querySelector('[data-currency]').textContent);
        this.querySelector('[data-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(chosen.dataset.price) * Number(quantity.value) / 100);
      });
    }
    async restorePayment() {
      const url = new URL(location.href);
      if (url.searchParams.get('rp_payment') !== this.dataset.sectionId) return;
      const id = Number(url.searchParams.get('rp_variant'));
      const quantity = Number(url.searchParams.get('rp_guests'));
      if (!Number.isSafeInteger(quantity) || quantity < 1) return;
      const radio = [...this.form.querySelectorAll('input[name="id"]')].find(input => Number(input.value) === id && !input.disabled);
      if (!radio) return;
      radio.checked = true;
      this.form.querySelector('[name="quantity"]').value = quantity;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      clearTimeout(this.syncTimer);
      const status = this.querySelector('[data-status]');
      status.textContent = this.messages.loading;
      try {
        const cart = await this.request('cart.js');
        const dates = this.form.querySelector('[name="properties[Retreat dates]"]').value;
        const item = cart.items.find(item => item.variant_id === id && item.quantity === quantity && item.properties && item.properties._retreat_payment_section === this.dataset.sectionId && item.properties['Retreat dates'] === dates);
        const selected = this.form.querySelector('input[name="id"]:checked');
        if (!item || Number(selected.value) !== id || Number(this.form.querySelector('[name="quantity"]').value) !== quantity) {
          status.textContent = this.messages.error;
          return;
        }
        this.querySelector('[data-payment]').hidden = false;
        this.querySelector('[data-prepare]').hidden = true;
        status.textContent = '';
        const code = url.searchParams.get('rp_discount');
        if (code) {
          this.querySelector('[data-discount-code]').value = code;
          const discounts = [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
          const applied = discounts.some(discount => String(discount.title).toLowerCase() === code.toLowerCase());
          this.querySelector('[data-discount-status]').textContent = applied ? code + ' — ' + this.dataset.discountApplied : this.messages.discount_error;
        }
      } catch (error) {
        status.textContent = error.message || this.messages.error;
      }
    }
    async applyDiscount() {
      if (this.busy) return;
      const input = this.querySelector('[data-discount-code]');
      const code = input.value.trim();
      const status = this.querySelector('[data-discount-status]');
      if (!code) { input.focus(); return; }
      this.busy = true;
      const button = this.querySelector('[data-apply-discount]');
      button.disabled = true;
      this.querySelector('.rp-wallets').hidden = true;
      this.querySelector('button[name="checkout"]').disabled = true;
      status.textContent = this.messages.discount_loading;
      try {
        const cart = await this.request('cart.js');
        const existing = (cart.discount_codes || []).filter(discount => discount.applicable).map(discount => discount.code);
        await this.request('cart/update.js', { discount: [...new Set([...existing, code])].join(',') });
        const url = new URL(location.href);
        url.searchParams.set('rp_discount', code);
        location.assign(url.href);
      } catch (error) {
        status.textContent = error.message || this.messages.discount_error;
        this.querySelector('.rp-wallets').hidden = false;
        this.querySelector('button[name="checkout"]').disabled = false;
      } finally {
        this.busy = false;
        button.disabled = false;
      }
    }
    async request(path, payload) {
      const response = await fetch((window.Shopify?.routes?.root || this.dataset.root || '/').replace(/\/?$/, '/') + path, {
        method: payload ? 'POST' : 'GET',
        headers: { 'Accept': 'application/json', ...(payload ? { 'Content-Type': 'application/json' } : {}) },
        ...(payload ? { body: JSON.stringify(payload) } : {})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || this.messages.error);
      return data;
    }
    async prepare() {
      if (this.busy || !this.form.reportValidity()) return;
      const chosen = this.form.querySelector('input[name="id"]:checked');
      if (!chosen || chosen.disabled) return;
      this.busy = true;
      const controls = [...this.form.querySelectorAll('input, button')];
      const states = controls.map(control => control.disabled);
      const quantity = Number(this.form.querySelector('[name="quantity"]').value);
      const id = Number(chosen.value);
      const dates = this.form.querySelector('[name="properties[Retreat dates]"]').value;
      const status = this.querySelector('[data-status]');
      this.querySelector('[data-payment]').hidden = true;
      controls.forEach(control => control.disabled = true);
      status.textContent = this.messages.loading;
      try {
        const initial = await this.request('cart.js');
        const owned = initial.items.filter(item => item.properties && item.properties._retreat_payment_section === this.dataset.sectionId);
        let target = owned.find(item => item.variant_id === id && item.properties['Retreat dates'] === dates);
        if (!target) {
          const added = await this.request('cart/add.js', { items: [{ id, quantity, properties: { 'Retreat dates': dates, '_retreat_payment_section': this.dataset.sectionId } }] });
          target = added.items[0];
        }
        const updates = {};
        owned.forEach(item => { if (item.key !== target.key) updates[item.key] = 0; });
        updates[target.key] = quantity;
        const updated = await this.request('cart/update.js', { updates });
        const actual = updated.items.find(item => item.variant_id === id && item.properties && item.properties._retreat_payment_section === this.dataset.sectionId && item.properties['Retreat dates'] === dates);
        if (!actual || actual.quantity !== quantity) throw new Error(this.messages.error);
        const url = new URL(location.href);
        url.searchParams.set('rp_payment', this.dataset.sectionId);
        url.searchParams.set('rp_variant', String(id));
        url.searchParams.set('rp_guests', String(quantity));
        location.assign(url.href);
      } catch (error) {
        status.textContent = error.message || this.messages.error;
        this.querySelector('[data-prepare]').hidden = false;
      } finally {
        controls.forEach((control, index) => control.disabled = states[index]);
        this.busy = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
